import { getRequest, postRequest, putRequest } from "../services/apiHelpers";

export const getUsers = async (params) => {
  try {
    const res = await getRequest({ url: "users", query: params });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const postUser = async (payload) => {
  try {
    const res = await postRequest({ url: "users", payload: payload });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const putUser = async ({ id, payload }) => {
  try {
    const res = await putRequest({
      url: "users",
      payload: payload,
      query: { USER_ID: id },
    });
    return res;
  } catch (error) {
    throw new Error(error.message);
  }
};
